import * as React from "react";
import {cx} from "emotion";

import "./form-mode.scss";

import {cs}               from "@Common/react/chain-services";
import {consumeContext}   from "@Common/react/context";
import {keyed}            from "@Common/react/keyed";
import {Static2}          from "@Common/react/static-2";
import {UseState}         from "@Common/react/use-state";
import {isDevQuan}        from "@Common/ui-components/debug/is-dev-quan";
import {ErrorHighlighter} from "@Common/ui-components/light/error-highlighter";
import {scrollIntoView}   from "@Common/ui-components/light/scroll-into-view";
import {getNestedValue}   from "@Common/utils/arr-path";
import {cascadeSum}       from "@Common/utils/cascade";

import {Line}           from "../../common/line";
import {sumCreditItems} from "../../common/sum-credit-items";

import {AdBudgetForm} from "./ad-budget-form/ad-budget-form";
import {ManualToggle} from "./manual-toggle";
import {setAdBudgets} from "@Xpresso/routes/customize/steps/checkout/credits-section/other-credits/ad-budget/set-ad-budgets";
import {Invoke} from "@Common/react/invoke";

export const FormMode = ({store, config, next}) => cs(
    consumeContext("apis"),

    ["eh", (_, next) => ErrorHighlighter({next})],
    ["domRef", (_, next) => Static2({next})],

    ["applied", (_, next) => next(getNestedValue(store.cart, ["appliedCredits", "adBudgets"]))],
    ["rawSelected", ({applied}, next) => next(!!applied?.length)],

    ["toggle", ({rawSelected, apis}, next) => ManualToggle({
        realValue: rawSelected,
        // initUserValue: isDevQuan(),
        onChange: (newValue, oldValue) => {
            if (newValue && !oldValue) {
                return null;
            } else {
                return async () => store.dispatch(setAdBudgets(null, {apis}));
            }
        },
        next,
    })],

    ["editing", (_, next) => UseState({next})],

    ({apis, toggle, eh, domRef, applied, editing}) => next({
        ...(toggle.faking || editing.value) && {
            invalid: true,

            highlightErrors: () => {
                eh.start();
                scrollIntoView(domRef.get());
            },
        },

        render: () => (
            <div className={cx("form-mode-5ri")}>
                {Line({
                    selected: {
                        value: toggle.value,
                        onChange: toggle.toggle,
                    },
                    label: "Ad Budget",
                    avaiAmount: sumCreditItems(store.cart.items, {itemAttr: "adbudget"}),
                    appliedAmount: applied && cascadeSum(store.cart, `appliedCredits.adBudgets[*].amount`),
                })}

                {!toggle.value && editing.value && (
                    Invoke({
                        action: () => editing.onChange(null),
                    })
                )}

                {toggle.value && cs(
                    ({}, next) => (
                        <div className={cx("box", eh.css)} ref={domRef.set}>
                            {next()}
                        </div>
                    ),
                    () => (
                        toggle.faking ? cs(
                            keyed("creating"),
                            () => Creating({
                                config,
                                onCreate: (data) => store.dispatch(setAdBudgets(data, {apis})),
                                onCancel: () => toggle.reset(),
                            }),
                        ) : editing.value ? cs(
                            keyed("editing"),
                            () => Editing({
                                config,
                                applied,
                                onEdit: async (data) => {
                                    await store.dispatch(setAdBudgets(data, {apis}));
                                    editing.onChange(false);
                                },
                                onCancel: () => editing.onChange(false),
                            })
                        ) : cs(
                            keyed("viewing"),
                            () => Viewing({
                                config,
                                applied,
                                onEdit: () => editing.onChange(true),
                            }),
                        )
                    )
                )}
            </div>
        ),
    }),
);

const Creating = ({config, onCreate, onCancel}) => cs(
    ["createForm", (_, next) => AdBudgetForm({
        config,
        next,
    })],
    ({createForm}) => <>
        {createForm.render({
            className: "form"
        })}

        <div className="actions">
            <button {...{
                onClick: onCancel,
                "xd-qa-type": "button",
                "xd-qa-name": "Ad Budget CANCEL",
            }}>
                CANCEL
            </button>
            <button {...{
                className: cx({disabled: !createForm.valid}),
                onClick: () => createForm.submit(async (data) => {
                    // console.log(data);
                    await onCreate(data);
                }),
                "xd-qa-type": "button",
                "xd-qa-name": "Ad Budget SUBMIT",
            }}>
                SUBMIT
            </button>
        </div>
    </>,
);

const Editing = ({config, applied, onEdit, onCancel}) => cs(
    ["editForm"  , ({}, next) => AdBudgetForm({
        config,
        savedData: applied,
        next,
    })],
    ({editForm}) => <>
        {editForm.render({
            className: "form",
        })}

        <div className="actions">
            <button {...{
                onClick: onCancel,
                "xd-qa-type": "button",
                "xd-qa-name": "Ad Budget CANCEL",
            }}>
                CANCEL
            </button>
            <button {...{
                className: cx({disabled: !editForm.valid}),

                onClick: () => editForm.submit(async (data) => {
                    await onEdit(data);
                }),
                "xd-qa-type": "button",
                "xd-qa-name": "Ad Budget SUBMIT",
            }}>
                SUBMIT
            </button>
        </div>
    </>,
);

const Viewing = ({config, applied, onEdit}) => cs(
    ["viewForm"  , ({}, next) => AdBudgetForm({
        config,
        savedData: applied,
        next,
    })],
    ({viewForm}) => <>
        {viewForm.render({
            className: "form",
            readOnly: true,
        })}

        <div className="actions">
            <a {...{
                onClick: onEdit,
                "xd-qa-type": "button",
                "xd-qa-name": "Ad Budget Edit",
            }}>
                Edit
            </a>
        </div>
    </>,
);
